/*
 * AbTestRunnerWrapper
 * Framework level module not to be modified for AbTest implementations
 * Used to check AbTestRunner class integrity check and visibility on the console when running on lower environments
 * */

import { has, silent } from './AbTestWrapper';

function isAbTestRunner(abTestRunner) {
    return (
        typeof abTestRunner === 'object' &&
        has(abTestRunner, 'objectType') &&
        has(abTestRunner, 'experiments')
    );
}

function assertIsAbTestRunner(abTestRunner) {
    if (!isAbTestRunner(abTestRunner)) {
        throw new TypeError('Not a fully implemented AbTest Runner. Experiments are not set');
    }
}

export function implementAbTestRunner(abTestRunner) {
    assertIsAbTestRunner(abTestRunner);
    if (silent) return;
    console.info('type: %s, class: %s', abTestRunner.objectType, abTestRunner.constructor.name);
}
